import {Box, Skeleton, SkeletonText} from '@chakra-ui/react';
import {FC} from 'react';

export const ProviderListSkeleton: FC = () => {
  return (
    <Box w={['100%', '320px']} minW="320px" mx="10px">
      <Skeleton h="180px" mb="12px" borderRadius="16px" />
      <SkeletonText skeletonHeight="30px" w="60%" noOfLines={1} mb="6px" />
      <SkeletonText skeletonHeight="18px" noOfLines={1} w="90%" />
    </Box>
  );
};
